import React, { Component } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend, Cell, Text, LabelList, Label } from 'recharts';
import { Popup } from 'semantic-ui-react';
import cm from 'helpers/commons';

class HBarChart extends Component {
  componentWillMount() {}

  customizedLabel = ({ x, y, fill, width, value }) => {
    let dom = null;
    return (
      <Text x={x} y={y} dy={16} dx={width + 10} fontSize="16" fontFamily="sans-serif" fill={fill} textAnchor="start">
        {cm.numberComma(value) + cm.unit()}
      </Text>
    );
  };

  monetaryUnit = (num) => {
    return cm.monetaryUnit(num);
  };

  commons = (value, name, props) => {
    return cm.numberComma(value) + cm.unit();
  };

  render() {
    const { width, height, data, legend, isMaxWidth } = this.props;

    let barChart = '';

    if (data) {
      barChart = (
        <BarChart
          layout="vertical"
          width={width}
          height={height}
          data={data}
          padding={{ right: 50 }}
          margin={{ top: 20, right: 30, bottom: 20, left: 20 }}
        >
          <XAxis type="number" tickFormatter={this.monetaryUnit} padding={{ right: 60 }} />
          <YAxis dataKey="name" type="category" orientation="left" width={isMaxWidth ? 180 : 100} />

          <CartesianGrid horizontal={false} stroke="#ebf3f0" />
          <Tooltip formatter={this.commons} />
          {legend ? <Legend /> : ''}

          <Bar
            dataKey="이번달 식대금액"
            barSize={20}
            minPointSize={5}
            isAnimationActive={false}
            label={this.customizedLabel}
          >
            {data.map((entry, idx) => {
              const color = entry.color ? entry.color : '#5A8CC7';
              return <Cell key={idx} fill={color} />;
            })}
          </Bar>
          <Bar dataKey="지난달 식대금액" barSize={20} fill="#C5C5C4" minPointSize={5} />
        </BarChart>
      );
    } else {
      barChart = (
        <div className="box-mid">
          <div className="mid">
            <h3>데이터 내역이 없습니다.</h3>
          </div>
        </div>
      );
    }

    return (
      <div style={{ width: width, height: height }} className="inBlock">
        {barChart}
      </div>
    );
  }
}

export default HBarChart;
